import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Usuario } from '../interfaces/book.interface';

@Injectable({
  providedIn: 'root'
})
export class UtilitariosService {

  fechaActual: any;
  fechaActualObj: any;
  fechaDia: any;
  fechaMes: any;
  fechaYear: any;
  fechaHora: any;
  fechaMinuto: any;

  constructor(
    public datepipe: DatePipe
  ) {
    console.log('Herramientas utilitarias');
    this.establecerFecha(); // Fecha Actual
  }


  /****************************************/
  /****** Metodos Utilitarios ******/
  /****************************************/

  getFechaActualObj() {
    return this.fechaActualObj;
  }

  getFechaActual() {
    return this.fechaActual;
  }

  nameDia(index) {
    var dia = new Array(7);
    dia[0] = "Domingo";
    dia[1] = "Lunes";
    dia[2] = "Martes";
    dia[3] = "Miércoles";
    dia[4] = "Jueves";
    dia[5] = "Viernes";
    dia[6] = "Sábado";
    return dia[index];
  }

  nameMes(index) {
    var mes = new Array(12);
    mes[0] = "Enero";
    mes[1] = "Febrero";
    mes[2] = "Marzo";
    mes[3] = "Abril";
    mes[4] = "Mayo";
    mes[5] = "Junio";
    mes[6] = "Julio";
    mes[7] = "Agosto";
    mes[8] = "Septiembre";
    mes[9] = "Octubre";
    mes[10] = "Noviembre";
    mes[11] = "Diciembre";
    return mes[index];
  }

  getFechaDia() {
    return this.fechaDia;
  }

  getFechaMes() {
    return this.fechaMes;
  }

  getFechaYear() {
    return this.fechaYear;
  }

  getFechaHora() {
    return this.fechaHora;
  }

  getFechaMinuto() {
    return this.fechaMinuto;
  }

  establecerFecha() {
    this.fechaActual = new Date();
    this.fechaActualObj = this.datepipe.transform(this.fechaActual, 'd/MM/y, h:mm:ss');

    this.fechaDia = this.datepipe.transform(this.fechaActual, 'd'); // # Dia
    this.fechaMes = this.datepipe.transform(this.fechaActual, 'MM');
    this.fechaYear = this.datepipe.transform(this.fechaActual, 'y');
    this.fechaHora = this.datepipe.transform(this.fechaActual, 'H');
    this.fechaMinuto = this.datepipe.transform(this.fechaActual, 'mm');

    console.log('Fecha: string ->',
      this.nameDia(this.fechaActual.getDay()) + ' ' +
      this.fechaDia + ' de ' +
      this.nameMes(parseInt(this.fechaMes) - 1) + '  ' +
      this.fechaMes + ' de ' +
      this.fechaYear
    );

    console.log('Fecha ->', this.fechaActual);
    console.log('Fecha: objeto ->', this.fechaActualObj);
  }


  convertirHtmlATexto(html: string): string {
    const codigoHtmlMap = {
      "&aacute;": "á",
      "&eacute;": "é",
      "&iacute;": "í",
      "&oacute;": "ó",
      "&uacute;": "ú",
      "&ntilde;": "ñ",
      "&uuml;": "ü",
      "&Aacute;": "Á",
      "&Eacute;": "É",
      "&Iacute;": "Í",
      "&Oacute;": "Ó",
      "&Uacute;": "Ú",
      "&Ntilde;": "Ñ",
      "&Uuml;": "Ü",
      "&ldquo;": "“",
      "&rdquo;": "”",
      "&lsquo;": "‘",
      "&rsquo;": "’",
      "&nbsp;": " ",
      "&copy;": "©",
      "&reg;": "®",
      "&trade;": "™",
      "&ndash;": "–",
      "&mdash;": "—",
      "&laquo;": "«",
      "&raquo;": "»",
      "&lt;": "<",
      "&gt;": ">",
      "&amp;": "&",
      "&cent;": "¢",
      "&pound;": "£",
      "&euro;": "€",
      "&yen;": "¥",
      "&sect;": "§",
      "&para;": "¶",
      "&ordm;": "º",
      "&ordf;": "ª",
      "&iexcl;": "¡",
      "&iquest;": "¿",
    };
  
    return html.replace(/&[^;]+;/g, match => {
      const codigoHtml = match.toLowerCase();
      return codigoHtmlMap[codigoHtml] || match;
    });
  }

  generarIdUnico(): string {
    let a = new Date();
    let b = a.toISOString();
    let c = b.replace(/[-T:.Z]/g, "");
    console.log("id único: :" + c);
    return c.toString();
  }

  filtroClavesRedATWATER(password: string) {
    
    if (password !== '1234'
      && password !== '4321'
      && password !== '1111'
      && password !== '0123'
      && password !== '3210'
      && password !== '0000'
      && password !== '1233'
      && password !== '0987'
      && password !== '9999'
      && password !== '8888'
      && password !== '7777'
      && password !== '6666'
      && password !== '5555'
      && password !== '4444'
      && password !== '3333'
      && password !== '2222'
    ) {
      if (password.length === 4) {
        console.log('Seguimiento de errores -> Clave aceptada.', password);
        return password;
      }
    } else {
      console.log('Seguimiento de errores -> Filtro de clave 4 numeros.', password);
      return false;
    }
  }

  removeHtmlTags(input: string): string {
    const div = document.createElement('div');
    div.innerHTML = input;
    return div.textContent || div.innerText || '';
  }


}
